import React from "react";
import Img from "./basic/Img";
import Cursor from "./basic/Cursor";

function BroadcastChannel() {
    return (
        <div className="broadcast">
            <Cursor setClass="contact-broadcast-tl" setImage="cursor180deg" />
            <Cursor setClass="contact-broadcast-br" setImage="cursor" />
            <div className="broadcast-title">
                <Img fileName={"channelTitle"} />
            </div>
            <div className="channel-icon-list">
                <div className="channel-icon-wrap">
                    <a
                        href="https://www.youtube.com/channel/UCTcJVDgfw411rqWCHb-16lg"
                        target="_blank"
                        rel="noopener noreferrer"
                        onClick={() => {
                            gtag("event", "click", {
                                event_category: "channel",
                                event_label: "channel_bungeishunju",
                            });
                        }}
                    >
                        <div className="channel-icon-image">
                            <Img fileName={"channelDenshi"} />
                        </div>
                    </a>
                </div>
                <div className="channel-icon-wrap">
                    <a
                        href="https://www.youtube.com/channel/UCJPEq-fDPYkJw_PHTv_zuiA"
                        target="_blank"
                        rel="noopener noreferrer"
                        onClick={() => {
                            gtag("event", "click", {
                                event_category: "channel",
                                event_label: "channel_bunshunonline",
                            });
                        }}
                    >
                        <div className="channel-icon-image">
                            <Img fileName={"channelOnline"} />
                        </div>
                    </a>
                </div>
                <div className="channel-icon-wrap ">
                    <a
                        href="https://www.youtube.com/c/BungeishunjuBOOKS"
                        target="_blank"
                        rel="noopener noreferrer"
                        onClick={() => {
                            gtag("event", "click", {
                                event_category: "channel",
                                event_label: "channel_bungeishunjultd",
                            });
                        }}
                    >
                        <div className="channel-icon-image channel-corp-adjust-image">
                            <Img fileName={"channelCorp"} />
                        </div>
                    </a>
                </div>
                <div className="channel-icon-wrap">
                    <a
                        href="https://www.youtube.com/channel/UCffZGrWOgS2w0sdx0kaELzA"
                        target="_blank"
                        rel="noopener noreferrer"
                        onClick={() => {
                            gtag("event", "click", {
                                event_category: "channel",
                                event_label: "channel_crea",
                            });
                        }}
                    >
                        <div className="channel-icon-image">
                            <Img fileName={"channelCrea"} />
                        </div>
                    </a>
                </div>
                <div className="channel-icon-wrap">
                    <a
                        href="https://www.youtube.com/channel/UCbkVbumsQCwVXy5UPs7zQrQ"
                        target="_blank"
                        rel="noopener noreferrer"
                        onClick={() => {
                            gtag("event", "click", {
                                event_category: "channel",
                                event_label: "channel_number",
                            });
                        }}
                    >
                        <div className="channel-icon-image">
                            <Img fileName={"channelNumber"} />
                        </div>
                    </a>
                </div>
                <div className="channel-icon-wrap">
                    <a
                        href="https://www.youtube.com/channel/UCWvohIHPWzcBJKCa79Tyn8w"
                        target="_blank"
                        rel="noopener noreferrer"
                        onClick={() => {
                            gtag("event", "click", {
                                event_category: "channel",
                                event_label: "channel_honnohanashi",
                            });
                        }}
                    >
                        <div className="channel-icon-image">
                            <Img fileName={"channelStory"} />
                        </div>
                    </a>
                </div>
            </div>
            <div className="channel-annotation">
                <p>※外部リンクに移動します。</p>
            </div>
        </div>
    );
}

export default BroadcastChannel;
